// extracted by mini-css-extract-plugin
export default {"mainWrapper":"UnpaidStamp_mainWrapper__YXFVR"};